@import "~@govbr-ds/core/src/components/menu/menu";
@import "~@govbr-ds/core/src/components/menu/mixins";
@include menu-header;
@include menu-body;
@include menu-footer;
@include menu-items;
@include menu-side-menu;

:host {
  display: block;
}

// Remove estilos padrão das listas dentro do componente para remover marcadores
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

// Estilização do nível 0 (menu dropdown) dentro do shadow deste componente
.menu-folder.drop-menu {
  > ul {
    background: var(--menu-background-submenu);
    display: none;
    padding: 0;
  }

  &.active {
    > ul {
      display: block;
      padding-left: var(--spacing-scale-3x);
    }
  }
}

// Decoração ativa do drill-down (quando o host possui [drill-active])
// Regras planas para respeitar max-nesting-depth do stylelint
:host([drill-active]) .side-menu > br-menu-item {
  display: none;
}

:host([drill-active]) .side-menu > ul {
  display: block;
  background: var(--menu-background-submenu);
}

// Quando a pasta estiver ativa mas sem filhos, mantenha o estilo de item simples
:host([drill-active]) .side-menu.active:has(> ul:empty) > ul {
  display: none;
}

:host([drill-active]) .side-menu.active:has(> ul:empty) > .menu-item {
  flex-direction: row;
  font-weight: inherit;
}

:host([drill-active]) .side-menu.active:has(> ul:empty) > .menu-item .icon {
  margin-right: var(--spacing-scale-2x);
}

:host([drill-active]) .side-menu.active:has(> ul:empty) > .menu-item .support {
  margin-right: 0;
}

// Oculta a linha de cabeçalho das listas ancestrais durante drill-down, independente do nível
:host([drill-ancestor]) {
  .drop-menu > br-menu-item,
  .side-menu > br-menu-item {
    display: none;
  }
}

.divider-list {
  border-bottom: 1px solid var(--border-color);
}
